/* tslint:disable */
/* eslint-disable */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ## A custom template from the reclaim-api/api-client         ##
 * ## repo was used.                                            ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import axios, { AxiosResponse, AxiosRequestConfig, AxiosInstance } from "axios";

export interface DefaultEmailSubscription {
  weeklyReport: boolean;
  disableMarketingEmails: boolean;
}

export enum DomainSetting {
  INVITEONLY = "INVITE_ONLY",
  REQUEST = "REQUEST",
  OPEN = "OPEN",
  AUTODOMAINCAPTURE = "AUTO_DOMAIN_CAPTURE",
}

export interface EntitlementValueObject {
  value: object;
  nextValue: object | null;
  nextEdition: ReclaimEdition | null;
}

export interface InvitationResponse {
  accept: boolean;
}

export enum InvitationStatus {
  ACCEPTED = "ACCEPTED",
  PENDING = "PENDING",
  DECLINED = "DECLINED",
}

export interface InvoiceLineItemView {
  description: string;
  amount: number;
  amountExcludingTax: number;
  quantity: number;
  unitAmountExcludingTax: number;
  periodStart: string | null;
  periodEnd: string | null;
  proration: boolean;
}

export interface InvoiceView {
  currency: SupportedCurrency;
  subtotal: number;
  subtotalExcludingTax: number;
  totalExcludingTax: number;
  total: number;
  startingBalance: number;
  totalDiscount: number;
  amountDue: number;
  dueDate: string | null;
  lines: InvoiceLineItemView[];
}

/**
 * Information about a team that a user could join.
 */
export interface JoinableTeam {
  teamId: number;
  name: string;
  paidProSeats: number;
  paidTeamSeats: number;
  memberCount: number;
  avatarUrls: string[];
  domainSetting: DomainSetting;
}

export enum MembershipRole {
  USER = "USER",
  ADMIN = "ADMIN",
}

export interface PartialTeam {
  name?: string | null;
  billingEmail?: string | null;
  autoSubscribe?: boolean | null;
  userInviteLevel?: ReclaimEdition | null;
  domainSetting?: DomainSetting | null;
}

export interface PartialTeamInvitation {
  /** Attempt to extract out a valid email address from what the user provided in the invite UI. */
  email: string;
  edition: ReclaimEdition | null;
  role: MembershipRole;
  inviteMessage: string;
}

export interface PartialTeamMember {
  edition: ReclaimEdition;
  role: MembershipRole;
}

export enum ReclaimEdition {
  NONE = "NONE",
  TRIAL = "TRIAL",
  ASSISTANT = "ASSISTANT",
  PRO = "PRO",
  TEAM = "TEAM",
  REWARD = "REWARD",
  LEGACYPROTRIAL = "LEGACY_PRO_TRIAL",
  LEGACYTEAMTRIAL = "LEGACY_TEAM_TRIAL",
  LITE = "LITE",
  STARTER = "STARTER",
  BUSINESS = "BUSINESS",
  TRIALBUSINESS = "TRIAL_BUSINESS",
  TRIALBUSINESS12W = "TRIAL_BUSINESS_12W",
  TRIALBUSINESSFORLEGACYPLANS = "TRIAL_BUSINESS_FOR_LEGACY_PLANS",
  ENTERPRISE = "ENTERPRISE",
  TEAMREWARD = "TEAM_REWARD",
}

export enum RequestedTeamStatus {
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export interface SlackOutsideHoursSetting {
  policy: string;
  message: string | null;
  dnd: boolean;
}

export interface SlackSettings {
  enabled?: boolean;
  personalSyncNotifyNew?: boolean;
  personalSyncNotifyUpdated?: boolean;
  personalSyncNotifyDeleted?: boolean;
  personalSyncNotificationsIncludingSelf?: boolean;
  habitNotifyUpcoming?: boolean;
  taskNotifyUpcoming?: boolean;
  travelNotify?: boolean;
  outsideHoursMigrated?: boolean;
  statusSync?: SlackSettingsStatusSync;
  statusEnabled?: boolean;
  privateStatus?: SlackStatusSetting;
  statuses?: Record<string, SlackStatusSetting>;
  outSideHours?: SlackOutsideHoursSetting;
}

export enum SlackSettingsStatusSync {
  OFF = "OFF",
  DEFAULT = "DEFAULT",
  BUSY = "BUSY",
  CUSTOM = "CUSTOM",
  TEAM = "TEAM",
}

export interface SlackStatusSetting {
  emoji?: string;
  template?: string;
  dnd?: boolean;
  enabled?: boolean;
}

export enum SubscriptionAvailability {
  AVAILABLE = "AVAILABLE",
  TOOMANYUSERS = "TOO_MANY_USERS",
  CALLUS = "CALL_US",
}

export interface SubscriptionChange {
  frequency: SubscriptionFrequency;
  edition: ReclaimEdition;
  seats: number;
  promoCode: string | null;
}

export interface SubscriptionChangeResult {
  upcomingInvoice: InvoiceView | null;
  membershipSummary: TeamMembershipSummary;
  pricingSummary: TeamPricingSummary;
  validPromoCode: boolean | null;
}

export enum SubscriptionFrequency {
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export interface SubscriptionOption {
  minSeats: number;
  maxSeats: number;
  prices: Record<string, SubscriptionPrice>;
}

export interface SubscriptionOptions {
  options: Record<string, SubscriptionOption>;
}

export interface SubscriptionPrice {
  selected: boolean;
  chargePrice: number;
  monthlyPrice: number;
  annualPrice: number;
  totalPrice: number;
  availability: SubscriptionAvailability;
}

export enum SubscriptionStatus {
  TRIALING = "TRIALING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum SupportedCurrency {
  Usd = "usd",
  Eur = "eur",
}

export interface TeamDomainView {
  teamId: number;
  domainName: string;
  oauthProvider: string;
}

export interface TeamInvitation {
  id: string;
  teamId: number;
  email: string;
  edition: ReclaimEdition;
  role: MembershipRole;
  status: InvitationStatus;
  created: string;
  creatorUserId?: string | null;
  updated: string;
  version: number;
  personalizedInviteMessage?: string | null;
}

export interface TeamInvoice {
  dueDate: string;
  total: string;
  link: string;
}

export interface TeamJoinResponse {
  userId: string;
  accept: boolean;
  role?: MembershipRole | null;
  editionAfterTrial?: ReclaimEdition | null;
}

export interface TeamMemberId {
  teamId: number;
  userId: string;
}

export interface TeamMemberView {
  teamMemberId: TeamMemberId;
  avatarUrl: string;
  membershipRole: MembershipRole;
  edition: ReclaimEdition;
  editionAfterTrial: ReclaimEdition;
  editionUsage?: ReclaimEdition | null;
  trialEnd: string;
  paidSeat?: boolean | null;
  trialSeat?: boolean | null;
  createdAt: string;
  email: string;
  domainName: string;
  firstName: string;
  lastName: string;
  name: string;
  status: TeamMemberViewStatus;
  invitationId: string;
  inviteUrl: string;
  personalizedInviteMessage: string;
  daysLeftInTrial: number;
  requestedTeamId: number;
  requestedTeamStatus: RequestedTeamStatus;
  schedulingLinkSlug: string;
  overage: boolean;
  trial: boolean;
}

export enum TeamMemberViewStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
}

export interface TeamMembershipCount {
  pendingCount: number;
  joinedCount: number;
  activeCount: number;
  paidCount: number;
}

export interface TeamMembershipSummary {
  paidCount: number;
  joinedCount: number;
  activeCount: number;
  overageCount: number;
  membershipOverage: boolean;
  usageOverage: boolean;
  overage: boolean;
  pendingCount: number;
  invitesAllowed: number;
  maxUsageEdition: ReclaimEdition | null;
  counts: Record<string, TeamMembershipCount>;
}

export interface TeamPricingSummary {
  trialEnd: string | null;
  daysLeftInTrial: number | null;
  subscriptionStatus: SubscriptionStatus;
  paidSeats: number;
  seatCounts: Record<string, number>;
  subscriptionFrequency: SubscriptionFrequency | null;
  edition: ReclaimEdition | null;
  trial: boolean | null;
  entitlements?: Record<string, EntitlementValueObject>;
  homogeneous: boolean;
  newPricing: boolean;
  customPricing: boolean;
  subscriptionEnd: string | null;
  autoRenew: boolean;
  currency: SupportedCurrency | null;
}

export interface TeamSettings {
  leaveTeam: boolean;
  shareReclaim: boolean;
  restrictEventDetails: boolean;
  defaultEmailSubscription: DefaultEmailSubscription;
  slackSettings: SlackSettings;
}

export interface TeamView {
  id: number;
  name: string;
  billingEmail: string;
  autoSubscribe: boolean;
  userInviteLevel: ReclaimEdition;
  domainSetting: DomainSetting;
  paidProSeats: number;
  paidTeamSeats: number;
  subscriptionFrequency: SubscriptionFrequency;
  proSeatsUsed: number;
  teamSeatsUsed: number;
  totalSeatsUsed: number;
  totalSeats: number;
  members?: TeamMemberView[] | null | null;
  membershipSummary: TeamMembershipSummary;
  subscriptionStatus: SubscriptionStatus;
  hasSubId: boolean;
  teamSettings: TeamSettings;
  teamEdition?: ReclaimEdition | null;
  entitlements?: Record<string, EntitlementValueObject>;
  homogeneous: boolean;
  newPricing: boolean;
  customPricing: boolean;
  pricingSummary: TeamPricingSummary;
}

export type LocalTime = string;

export namespace team {
  /**
   * @tags team
   * @name newSession
   * @request GET:/team/create/subscription/session
   */
  export namespace NewSession {
    export type RequestQuery = {
      frequency: SubscriptionFrequency;
      seats: number;
      edition: ReclaimEdition;
      currency?: SupportedCurrency | null;
      successUrl: string;
      cancelUrl: string;
    };
    export type RequestBody = never;
    export type ResponseBody = object;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name getCurrentTeam
   * @request GET:/team/current
   */
  export namespace GetCurrentTeam {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamView;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name patchTeam
   * @request PATCH:/team/current
   */
  export namespace PatchTeam {
    export type RequestQuery = {};
    export type RequestBody = PartialTeam;
    export type ResponseBody = TeamView;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name getCurrentTeamDomains
   * @request GET:/team/current/domains
   */
  export namespace GetCurrentTeamDomains {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamDomainView[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name deleteInvitation
   * @request DELETE:/team/current/invitation/{id}
   */
  export namespace DeleteInvitation {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = object;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name getInvitations
   * @request GET:/team/current/invitations
   */
  export namespace GetInvitations {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamInvitation[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name createInvitation
   * @request POST:/team/current/invitations
   */
  export namespace CreateInvitation {
    export type RequestQuery = { source?: string | null };
    export type RequestBody = PartialTeamInvitation[];
    export type ResponseBody = TeamInvitation[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name updateInvitation
   * @request PATCH:/team/current/invitations/{inviteId}
   */
  export namespace UpdateInvitation {
    export type RequestQuery = {};
    export type RequestBody = PartialTeamMember;
    export type ResponseBody = TeamInvitation;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name getInviteableTeamMembers
   * @summary Returns team members that are not members of the user's team, overlap with domain(s) in the user's team, and do not belong to paying teams.
   * @request GET:/team/current/inviteable
   * @description Returns team members that are not members of the user's team, overlap with domain(s) in the user's team, and do not belong to paying teams.
   */
  export namespace GetInviteableTeamMembers {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamMemberView[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name joinResponses
   * @request POST:/team/current/joinResponses
   */
  export namespace JoinResponses {
    export type RequestQuery = {};
    export type RequestBody = TeamJoinResponse[];
    export type ResponseBody = TeamMemberView[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name leaveTeam
   * @request POST:/team/current/leave
   */
  export namespace LeaveTeam {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamView;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name getMembers
   * @request GET:/team/current/members
   */
  export namespace GetMembers {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamMemberView[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name deleteMember
   * @request DELETE:/team/current/members
   */
  export namespace DeleteMember {
    export type RequestQuery = { userId: string };
    export type RequestBody = never;
    export type ResponseBody = object;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name patchMember
   * @request PATCH:/team/current/members
   */
  export namespace PatchMember {
    export type RequestQuery = { userId: string };
    export type RequestBody = PartialTeamMember;
    export type ResponseBody = TeamMemberView;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name getMembership
   * @request GET:/team/current/membership
   */
  export namespace GetMembership {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamMemberView;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name getRequests
   * @summary Returns team members that have requested to be part of the user's team (and currently are not).
   * @request GET:/team/current/requests
   * @description Returns team members that have requested to be part of the user's team (and currently are not).
   */
  export namespace GetRequests {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamMemberView[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name cancelSubscription
   * @request DELETE:/team/current/subscription
   */
  export namespace CancelSubscription {
    export type RequestQuery = { reason?: string | null };
    export type RequestBody = never;
    export type ResponseBody = object;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name subscriptionOptions
   * @request GET:/team/current/subscription-options
   */
  export namespace SubscriptionOptions {
    export type RequestQuery = { quantity?: number | null; currency?: SupportedCurrency | null };
    export type RequestBody = never;
    export type ResponseBody = SubscriptionOptions;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name subscriptionChange
   * @request POST:/team/current/subscription/change
   */
  export namespace SubscriptionChange {
    export type RequestQuery = {};
    export type RequestBody = SubscriptionChange;
    export type ResponseBody = SubscriptionChangeResult;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name previewSubscriptionChange
   * @request POST:/team/current/subscription/change-preview
   */
  export namespace PreviewSubscriptionChange {
    export type RequestQuery = {};
    export type RequestBody = SubscriptionChange;
    export type ResponseBody = SubscriptionChangeResult;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name reinstateSubscription
   * @request POST:/team/current/subscription/reinstate
   */
  export namespace ReinstateSubscription {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = SubscriptionChangeResult;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name manageSession
   * @request GET:/team/current/subscription/session
   */
  export namespace ManageSession {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = object;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name endTrial
   * @request DELETE:/team/current/trial
   */
  export namespace EndTrial {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = object;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name editions
   * @request GET:/team/editions
   */
  export namespace Editions {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = Record<string, Record<string, EntitlementValueObject>>;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name listInvoices
   * @request GET:/team/invoices
   */
  export namespace ListInvoices {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = TeamInvoice[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name getJoinableTeams
   * @request GET:/team/joinable
   */
  export namespace GetJoinableTeams {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = JoinableTeam[];
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name acceptInvitation
   * @request POST:/team/{teamId}/invitations/{invitationId}
   */
  export namespace AcceptInvitation {
    export type RequestQuery = {};
    export type RequestBody = InvitationResponse;
    export type ResponseBody = object;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name requestToJoinTeam
   * @summary A request from a user to join a team.
   * @request POST:/team/{teamId}/request
   * @description A request from a user to join a team.
   */
  export namespace RequestToJoinTeam {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = any;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }

  /**
   * @tags team
   * @name cancelRequestToJoinTeam
   * @request POST:/team/{teamId}/request/cancel
   */
  export namespace CancelRequestToJoinTeam {
    export type RequestQuery = {};
    export type RequestBody = never;
    export type ResponseBody = any;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }
}
export namespace webhook {
  /**
   * @name post
   * @request POST:/webhook/stripe
   */
  export namespace Post {
    export type RequestQuery = {};
    export type RequestBody = LocalTime;
    export type ResponseBody = object;
    export type ErrorType = { status: 401; response: unknown } | { status: 500; response: unknown };
  }
}

export const HEADER_BUILD_ID = "X-Reclaim-Build-Id";

export type RequestParams = Omit<AxiosRequestConfig, "url" | "data" | "method"> & {
  secure?: boolean;
};

// TODO: The need for this is hard codded into the codegen source... so dumb
enum BodyType {
  Json,
}

export type RequestQueryParamsType = Record<string | number, any>;

export type ApiConfig<SecurityDataType> = {
  baseUrl?: string;
  baseApiParams?: RequestParams;
  securityWorker?: (securityData: SecurityDataType) => RequestParams;
};

/** Overrided Promise type. Needs for additional typings of `.catch` callback */
export type TypedErrorPromise<ResolveType, RejectType = unknown> = Omit<Promise<ResolveType>, "then" | "catch"> & {
  then<TResult1 = ResolveType, TResult2 = never>(
    onfulfilled?: ((value: ResolveType) => TResult1 | PromiseLike<TResult1>) | undefined | null,
    onrejected?: ((reason: RejectType) => TResult2 | PromiseLike<TResult2>) | undefined | null,
  ): Promise<TResult1 | TResult2>;
  catch<TResult = never>(
    onrejected?: ((reason: RejectType) => TResult | PromiseLike<TResult>) | undefined | null,
  ): Promise<ResolveType | TResult>;
  finally<TResult = never>(onfinally?: (() => void) | undefined | null): Promise<ResolveType | TResult>;
  readonly [Symbol.toStringTag]: string;
};

export class ReclaimApiError<
  E extends { status: number; response?: unknown | null } = { status: number; response?: unknown | null },
> extends Error {
  status: E["status"];
  statusText?: string;
  headers: unknown;
  body: E["response"];
  handled: boolean;

  constructor(res: AxiosResponse, message?: string) {
    super(message);

    if (!res && !message) message = "No response object";

    this.status = res?.status;
    this.statusText = res?.statusText || res.data?.message || message;
    this.headers = res?.headers;
    this.body = res?.data;
  }
}

export class NetworkError extends Error {
  status: "NetworkError" = "NetworkError";
  statusText: any;
  headers: any;
  body: any;
  handled: boolean;

  constructor(res: AxiosResponse, message?: string) {
    super(message);

    if (!res && !message) message = "No response object";

    this.statusText = res?.statusText || res.data?.message || message;
    this.headers = res?.headers;
    this.body = res?.data;
  }
}

// export type ClientConfig = ApiConfig<SecurityDataType,> & {BUILD_ID?: string}
export type ClientConfig = ApiConfig<any> & { BUILD_ID?: string };

class HttpClient<SecurityDataType> {
  public baseUrl: string = "https://api.app.reclaim.ai/api";
  public client: AxiosInstance;
  private securityData: SecurityDataType = null as any;
  private securityWorker: ApiConfig<SecurityDataType>["securityWorker"] = (() => {}) as any;
  private baseApiParams: RequestParams = {
    headers: {
      "Content-Type": "application/json",
      Referrer: "no-referrer",
    },
  };

  private requestHooks = {};
  private responseHooks = {};

  constructor({ baseUrl, baseApiParams, securityWorker, BUILD_ID }: ClientConfig = { BUILD_ID: "unknown" }) {
    if (!!baseUrl) this.baseUrl = baseUrl;
    if (!!baseApiParams) this.baseApiParams = baseApiParams;
    if (!!securityWorker) this.securityWorker = securityWorker;
    this.client = axios.create({
      baseURL: baseUrl || this.baseUrl,
      withCredentials: true,
      headers: {
        [HEADER_BUILD_ID]: BUILD_ID,
        ...(this.baseApiParams.headers || {}),
        post: {
          "Content-Type": "application/json; charset=utf-8",
        },
      },
    });
    this.client.interceptors.request.use((config) => {
      Object.keys(this.requestHooks).forEach((name) => {
        this.requestHooks[name](config);
      });

      return config;
    });

    this.client.interceptors.response.use(
      (r) => {
        Object.keys(this.responseHooks).forEach((name) => {
          if (r.status) {
            return this.responseHooks[`${name} - Status: ${r.status}`](new ReclaimApiError(r));
          }

          this.responseHooks[`${name} - Status: network`](new NetworkError(r));
        });
        return r;
      },
      (error) => {
        Object.keys(this.responseHooks).forEach((name) => {
          this.responseHooks[name](error);
        });
        return error;
      },
    );
  }

  public setSecurityData = (data: SecurityDataType) => {
    this.securityData = data;
  };

  private addQueryParam(query: RequestQueryParamsType, key: string) {
    return (
      encodeURIComponent(key) + "=" + encodeURIComponent(Array.isArray(query[key]) ? query[key].join(",") : query[key])
    );
  }

  protected addQueryParams(rawQuery?: RequestQueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys.length
      ? `?${keys
          .map((key) =>
            typeof query[key] === "object" && !Array.isArray(query[key])
              ? this.addQueryParams(query[key] as object).substring(1)
              : this.addQueryParam(query, key),
          )
          .join("&")}`
      : "";
  }

  public registerRequestHook(name: string, fn: (config: AxiosRequestConfig) => void | Promise<void>) {
    this.requestHooks[name] = fn;
  }

  public registerResponseHook(
    name: string,
    status: 401 | 500 | "NetworkError",
    fn: (error: any) => void | Promise<void>,
  ) {
    this.responseHooks[`${name} - Status: ${status}`] = fn;
  }

  public request = <T extends unknown, E extends { status: number; response?: unknown | null }>(
    path: string,
    method: AxiosRequestConfig["method"],
    { secure, ...params }: RequestParams = {},
    data?: any,
    _dumbUnusedBodyType?: any,
    secureByDefault?: boolean,
  ): TypedErrorPromise<T, ReclaimApiError<E> | NetworkError> =>
    this.client
      .request({
        url: path,
        ...params,
        method,
        data,
        validateStatus: function (status) {
          return true;
        },
      })
      .then((r) => {
        if (r.status >= 200 && r.status < 300) {
          return !!r.data ? r.data : null;
        } else if (!r.status) {
          throw new NetworkError(r);
        } else {
          throw new ReclaimApiError(r);
        }
      });
}

/**
 * @title Reclaim Billing API
 * @version 0.1
 * @baseUrl https://api.app.reclaim.ai/api
 * Reclaim's awesome API
 */
export class ReclaimApi<SecurityDataType = any> extends HttpClient<SecurityDataType> {
  team = {
    /**
     * @tags team
     * @name newSession
     * @request GET:/team/create/subscription/session
     */
    newSession: <ErrorTypes extends { status: number; response: any }>(
      query: {
        frequency: SubscriptionFrequency;
        seats: number;
        edition: ReclaimEdition;
        currency?: SupportedCurrency | null;
        successUrl: string;
        cancelUrl: string;
      },
      params?: RequestParams,
    ) =>
      this.request<object, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/create/subscription/session${this.addQueryParams(query)}`,
        "GET",
        params,
      ),

    /**
     * @tags team
     * @name getCurrentTeam
     * @request GET:/team/current
     */
    getCurrentTeam: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<TeamView, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/current`,
        "GET",
        params,
      ),

    /**
     * @tags team
     * @name patchTeam
     * @request PATCH:/team/current
     */
    patchTeam: <ErrorTypes extends { status: number; response: any }>(data: PartialTeam, params?: RequestParams) =>
      this.request<TeamView, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/current`,
        "PATCH",
        params,
        data,
      ),

    /**
     * @tags team
     * @name getCurrentTeamDomains
     * @request GET:/team/current/domains
     */
    getCurrentTeamDomains: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        TeamDomainView[],
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/domains`, "GET", params),

    /**
     * @tags team
     * @name deleteInvitation
     * @request DELETE:/team/current/invitation/{id}
     */
    deleteInvitation: <ErrorTypes extends { status: number; response: any }>(id: string, params?: RequestParams) =>
      this.request<object, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/current/invitation/${id}`,
        "DELETE",
        params,
      ),

    /**
     * @tags team
     * @name getInvitations
     * @request GET:/team/current/invitations
     */
    getInvitations: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        TeamInvitation[],
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/invitations`, "GET", params),

    /**
     * @tags team
     * @name createInvitation
     * @request POST:/team/current/invitations
     */
    createInvitation: <ErrorTypes extends { status: number; response: any }>(
      data: PartialTeamInvitation[],
      query?: { source?: string | null },
      params?: RequestParams,
    ) =>
      this.request<
        TeamInvitation[],
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/invitations${this.addQueryParams(query)}`, "POST", params, data),

    /**
     * @tags team
     * @name updateInvitation
     * @request PATCH:/team/current/invitations/{inviteId}
     */
    updateInvitation: <ErrorTypes extends { status: number; response: any }>(
      inviteId: string,
      data: PartialTeamMember,
      params?: RequestParams,
    ) =>
      this.request<
        TeamInvitation,
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/invitations/${inviteId}`, "PATCH", params, data),

    /**
     * @tags team
     * @name getInviteableTeamMembers
     * @summary Returns team members that are not members of the user's team, overlap with domain(s) in the user's team, and do not belong to paying teams.
     * @request GET:/team/current/inviteable
     * @description Returns team members that are not members of the user's team, overlap with domain(s) in the user's team, and do not belong to paying teams.
     */
    getInviteableTeamMembers: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        TeamMemberView[],
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/inviteable`, "GET", params),

    /**
     * @tags team
     * @name joinResponses
     * @request POST:/team/current/joinResponses
     */
    joinResponses: <ErrorTypes extends { status: number; response: any }>(
      data: TeamJoinResponse[],
      params?: RequestParams,
    ) =>
      this.request<
        TeamMemberView[],
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/joinResponses`, "POST", params, data),

    /**
     * @tags team
     * @name leaveTeam
     * @request POST:/team/current/leave
     */
    leaveTeam: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<TeamView, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/current/leave`,
        "POST",
        params,
      ),

    /**
     * @tags team
     * @name getMembers
     * @request GET:/team/current/members
     */
    getMembers: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        TeamMemberView[],
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/members`, "GET", params),

    /**
     * @tags team
     * @name deleteMember
     * @request DELETE:/team/current/members
     */
    deleteMember: <ErrorTypes extends { status: number; response: any }>(
      query: { userId: string },
      params?: RequestParams,
    ) =>
      this.request<object, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/current/members${this.addQueryParams(query)}`,
        "DELETE",
        params,
      ),

    /**
     * @tags team
     * @name patchMember
     * @request PATCH:/team/current/members
     */
    patchMember: <ErrorTypes extends { status: number; response: any }>(
      query: { userId: string },
      data: PartialTeamMember,
      params?: RequestParams,
    ) =>
      this.request<
        TeamMemberView,
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/members${this.addQueryParams(query)}`, "PATCH", params, data),

    /**
     * @tags team
     * @name getMembership
     * @request GET:/team/current/membership
     */
    getMembership: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        TeamMemberView,
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/membership`, "GET", params),

    /**
     * @tags team
     * @name getRequests
     * @summary Returns team members that have requested to be part of the user's team (and currently are not).
     * @request GET:/team/current/requests
     * @description Returns team members that have requested to be part of the user's team (and currently are not).
     */
    getRequests: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        TeamMemberView[],
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/requests`, "GET", params),

    /**
     * @tags team
     * @name cancelSubscription
     * @request DELETE:/team/current/subscription
     */
    cancelSubscription: <ErrorTypes extends { status: number; response: any }>(
      query?: { reason?: string | null },
      params?: RequestParams,
    ) =>
      this.request<object, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/current/subscription${this.addQueryParams(query)}`,
        "DELETE",
        params,
      ),

    /**
     * @tags team
     * @name subscriptionOptions
     * @request GET:/team/current/subscription-options
     */
    subscriptionOptions: <ErrorTypes extends { status: number; response: any }>(
      query?: { quantity?: number | null; currency?: SupportedCurrency | null },
      params?: RequestParams,
    ) =>
      this.request<
        SubscriptionOptions,
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/subscription-options${this.addQueryParams(query)}`, "GET", params),

    /**
     * @tags team
     * @name subscriptionChange
     * @request POST:/team/current/subscription/change
     */
    subscriptionChange: <ErrorTypes extends { status: number; response: any }>(
      data: SubscriptionChange,
      params?: RequestParams,
    ) =>
      this.request<
        SubscriptionChangeResult,
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/subscription/change`, "POST", params, data),

    /**
     * @tags team
     * @name previewSubscriptionChange
     * @request POST:/team/current/subscription/change-preview
     */
    previewSubscriptionChange: <ErrorTypes extends { status: number; response: any }>(
      data: SubscriptionChange,
      params?: RequestParams,
    ) =>
      this.request<
        SubscriptionChangeResult,
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/subscription/change-preview`, "POST", params, data),

    /**
     * @tags team
     * @name reinstateSubscription
     * @request POST:/team/current/subscription/reinstate
     */
    reinstateSubscription: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        SubscriptionChangeResult,
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/current/subscription/reinstate`, "POST", params),

    /**
     * @tags team
     * @name manageSession
     * @request GET:/team/current/subscription/session
     */
    manageSession: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<object, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/current/subscription/session`,
        "GET",
        params,
      ),

    /**
     * @tags team
     * @name endTrial
     * @request DELETE:/team/current/trial
     */
    endTrial: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<object, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/current/trial`,
        "DELETE",
        params,
      ),

    /**
     * @tags team
     * @name editions
     * @request GET:/team/editions
     */
    editions: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        Record<string, Record<string, EntitlementValueObject>>,
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/editions`, "GET", params),

    /**
     * @tags team
     * @name listInvoices
     * @request GET:/team/invoices
     */
    listInvoices: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<TeamInvoice[], { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/invoices`,
        "GET",
        params,
      ),

    /**
     * @tags team
     * @name getJoinableTeams
     * @request GET:/team/joinable
     */
    getJoinableTeams: <ErrorTypes extends { status: number; response: any }>(params?: RequestParams) =>
      this.request<
        JoinableTeam[],
        { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes
      >(`/team/joinable`, "GET", params),

    /**
     * @tags team
     * @name acceptInvitation
     * @request POST:/team/{teamId}/invitations/{invitationId}
     */
    acceptInvitation: <ErrorTypes extends { status: number; response: any }>(
      teamId: number,
      invitationId: string,
      data: InvitationResponse,
      params?: RequestParams,
    ) =>
      this.request<object, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/${teamId}/invitations/${invitationId}`,
        "POST",
        params,
        data,
      ),

    /**
     * @tags team
     * @name requestToJoinTeam
     * @summary A request from a user to join a team.
     * @request POST:/team/{teamId}/request
     * @description A request from a user to join a team.
     */
    requestToJoinTeam: <ErrorTypes extends { status: number; response: any }>(teamId: number, params?: RequestParams) =>
      this.request<any, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/${teamId}/request`,
        "POST",
        params,
      ),

    /**
     * @tags team
     * @name cancelRequestToJoinTeam
     * @request POST:/team/{teamId}/request/cancel
     */
    cancelRequestToJoinTeam: <ErrorTypes extends { status: number; response: any }>(
      teamId: number,
      params?: RequestParams,
    ) =>
      this.request<any, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/team/${teamId}/request/cancel`,
        "POST",
        params,
      ),
  };
  webhook = {
    /**
     * @name post
     * @request POST:/webhook/stripe
     */
    post: <ErrorTypes extends { status: number; response: any }>(data: LocalTime, params?: RequestParams) =>
      this.request<object, { status: 401; response: unknown } | { status: 500; response: unknown } | ErrorTypes>(
        `/webhook/stripe`,
        "POST",
        params,
        data,
      ),
  };
}
